import PropTypes from 'prop-types';

const modalPropTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  onNext: PropTypes.func,
};

export default modalPropTypes;
